<script>
	import options from './ClientList.options'
	export default options
</script>

<template>
	<article class="nlx-client-list">

		<div class="nlx-client-list__heading-section">
			<h2 class="nlx-client-list__heading-title">{{getLabel('clientListTitle')}}</h2>
			<div class="nlx-client-list__shown-entry-amount">{{getLabel('shows')}} <span class="nlx-client-list__hight-light">{{displayData.entries.length}}</span> {{getLabel('of')}} <b>{{totalAmountOfEntries.length}}</b></div>
		</div>

		<div class="nlx-client-list__search-section">
			<input class="nlx-client-list__search-input" @input="searchCustomerList" v-model="searchInput" type="text" :placeholder="getLabel('clientListSearchLabel')"/>
		</div>

		<template v-if="displayData">
			<TableComponentGeneric :tableData="displayData"/>
		</template>

		<template v-else>
			<div class="nlx-loading-spinner-overlay">
				<div class="nlx-loading-spinner"></div>
			</div>
		</template>

		<div v-if="isAllClientsShown" class="nlx-client-list__show-more-button-container">
			<button @click="showMoreClients" class="nlx-button nlx-button--black">{{getLabel('show')}} <span class="nlx-client-list__hight-light">{{clientListTakeAmount}}</span> {{getLabel('more')}}</button>
		</div>

	</article>
</template>
